import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconExclamationTriangle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconExclamationTriangle"><Path d="M12 9.5V14M12 16.49V16.5M12 3L2.25 19.5H21.75L12 3Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconExclamationTriangle;
